import { projectPath } from "./projectPath";

// Build an in-app URL for a page. The active project + branch are read from the
// current URL (the single source of truth) and prefixed automatically, so a
// call like createPageUrl("data-elements") becomes
// "/p/<slug>/b/<branch>/data-elements". Pass an explicit { slug, branch } to
// target a different project (e.g. switching projects / opening a demo).
export const createPageUrl = (pageName, params) => {
  return projectPath(pageName, params || {});
};

export { projectPath, parseProjectPath, currentProjectSlug, currentBranch, DEFAULT_BRANCH } from "./projectPath";
